// components/artifacts/ArtifactLoadingState.js - 아티팩트 로딩/생성 중 상태 컴포넌트

import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

/**
 * 아티팩트 로딩/생성 중 상태 컴포넌트
 * @param {object} props
 * @param {string} props.artifactType - 아티팩트 타입 ('plan', 'survey', 'guideline')
 * @param {number} props.generationStep - 현재 생성 단계
 * @param {function} props.getGenerationSteps - 생성 단계 배열을 반환하는 함수
 */
const ArtifactLoadingState = ({ artifactType, generationStep, getGenerationSteps }) => {
  const steps = getGenerationSteps(artifactType);
  const title =
    artifactType === "plan"
      ? "계획서를 생성하고 있습니다"
      : artifactType === "survey"
      ? "스크리너 설문을 생성하고 있습니다"
      : artifactType === "guideline"
      ? "진행 가이드를 생성하고 있습니다"
      : "생성하고 있습니다";

  return (
    <div
      style={{
        maxWidth: "700px",
        margin: "0 auto",
        padding: "40px 20px",
      }}
    >
      <h2
        style={{
          fontSize: "24px",
          fontWeight: 700,
          color: "#1f2937",
          textAlign: "center",
          marginBottom: "40px",
        }}
      >
        {title}
      </h2>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        {steps.map((stepText, index) => (
          <div
            key={index}
            className="generation-step-item"
            style={{
              background:
                index < generationStep
                  ? "#dcfce7"
                  : index === generationStep
                  ? "#eff6ff"
                  : "#f9fafb",
              border:
                index === generationStep
                  ? "2px solid #7C9CE8"
                  : "1px solid #e5e7eb",
              opacity: index > generationStep ? 0.5 : 1,
            }}
          >
            <div
              className="generation-step-icon"
              style={{
                background:
                  index < generationStep
                    ? "#16a34a"
                    : index === generationStep
                    ? "#7C9CE8"
                    : "#e5e7eb",
              }}
            >
              {index < generationStep ? (
                "✓"
              ) : index === generationStep ? (
                <FontAwesomeIcon icon={faSpinner} spin />
              ) : (
                index + 1
              )}
            </div>
            <div
              className="generation-step-text"
              style={{
                fontWeight: index === generationStep ? 600 : 500,
              }}
            >
              {stepText}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ArtifactLoadingState;

